import helprightimg from "../../../../assets/images/need-help-right.jpg";
import helpleftimg from "../../../../assets/images/need-help-left.jpg";

export default function StillNeedHelp() {
    return (
        <section className="faq-help-section">
            <div className="faq-help-container">
                {helpleftimg && (
                    <div className="faq-help-img-1">
                        <img
                            src={helpleftimg}
                            alt="Customer support illustration"
                        />
                    </div>
                )}

                <div className="faq-help-content">
                    <h3>Still need help?</h3>
                    <p>
                        Check out our above FAQs for quick answers to common questions.
                        <br />
                        Still need assistance? Feel free to email us at:
                    </p>
                    <a href="mailto:care@obsessions.co.in">
                        Email us at care@obsessions.co.in
                    </a>
                </div>

                {helprightimg && (
                    <div className="faq-help-img-2">
                        <img
                            src={helprightimg}
                            alt="Customer support illustration"
                        />
                    </div>
                )}
            </div>
        </section>
    );
}
